// Material ui components
// Apollo client
import { useQuery } from '@apollo/client';
import { Box, Grid, makeStyles } from '@material-ui/core';

import CardServiceProviderDivider from '../../../../components/CardServiceProviderDivider';
import { If } from '../../../../components/If';
import { PanelLogin } from '../../../../components/PanelLogin';
import Subtitle from '../../../../components/Subtitle';
import { useAuthContext } from '../../../../context/AuthContextProvider';
import ipanema from '../../../../graphql/clients/ipanema';
import { GET_DETAILS_FII_SERVICE_PROVIDERS_BY_OPERATION_HASH_ID } from '../../../../graphql/queries';

// Styles
const useStyles = makeStyles((theme) => ({
  title: {
    fontWeight: theme.typography.fontWeightBold,
  },
  divider: {
    height: 2,
    backgroundColor: theme.palette.common.black,
  },
}));

export default function OperationFIIServiceProvider({ hash }) {
  const { auth } = useAuthContext();
  const classes = useStyles();
  const { data, loading, error } = useQuery(
    GET_DETAILS_FII_SERVICE_PROVIDERS_BY_OPERATION_HASH_ID,
    {
      variables: { hash },
      client: ipanema,
      skip: !auth?.user?.subscription?.plan?.permissions[
        'operacoes_fii_prestadores_de_servicos'
      ],
    },
  );

  return (
    <Box p={2}>
      <Box>
        <If
          condition={
            !auth?.user?.subscription?.plan?.permissions[
              'operacoes_fii_prestadores_de_servicos'
            ]
          }>
          <PanelLogin />
        </If>
        <If
          condition={
            auth?.user?.subscription?.plan?.permissions[
              'operacoes_fii_prestadores_de_servicos'
            ]
          }>
          <Grid container spacing={3}>
            {loading || error ? null : (
              <>
                <If
                  condition={
                    data?.getDetailsFiiServiceProvidersByOperationHashId
                      ?.administrators?.length
                  }>
                  <Grid item xs={12} sm={12} md={12}>
                    <Subtitle title="Administrador" />
                  </Grid>
                  {data?.getDetailsFiiServiceProvidersByOperationHashId?.administrators?.map(
                    (administrator, index) => (
                      <Grid item xs={12} sm={6} md={4} key={index}>
                        <CardServiceProviderDivider
                          serviceProvider="Administrador"
                          classes={classes}
                          {...administrator}
                        />
                      </Grid>
                    ),
                  )}
                </If>
              </>
            )}
            {loading || error ? null : (
              <>
                <If
                  condition={
                    data?.getDetailsFiiServiceProvidersByOperationHashId
                      ?.managers?.length
                  }>
                  <Grid item xs={12} sm={12} md={12}>
                    <Subtitle title="Gestor" />
                  </Grid>
                  {data?.getDetailsFiiServiceProvidersByOperationHashId?.managers?.map(
                    (manager, index) => (
                      <Grid item xs={12} sm={6} md={4} key={index}>
                        <CardServiceProviderDivider
                          serviceProvider="Gestor"
                          classes={classes}
                          {...manager}
                        />
                      </Grid>
                    ),
                  )}
                </If>
              </>
            )}
            {loading || error ? null : (
              <>
                <If
                  condition={
                    data?.getDetailsFiiServiceProvidersByOperationHashId
                      ?.custodians?.length
                  }>
                  <Grid item xs={12} sm={12} md={12}>
                    <Subtitle title="Custodiante" />
                  </Grid>
                  {data?.getDetailsFiiServiceProvidersByOperationHashId?.custodians?.map(
                    (custodian, index) => (
                      <Grid item xs={12} sm={6} md={4} key={index}>
                        <CardServiceProviderDivider
                          serviceProvider="Custodiante"
                          classes={classes}
                          {...custodian}
                        />
                      </Grid>
                    ),
                  )}
                </If>
              </>
            )}
            {loading || error ? null : (
              <>
                <If
                  condition={
                    data?.getDetailsFiiServiceProvidersByOperationHashId
                      ?.consultants?.length
                  }>
                  <Grid item xs={12} sm={12} md={12}>
                    <Subtitle title="Consultor de Crédito" />
                  </Grid>
                  {data?.getDetailsFiiServiceProvidersByOperationHashId?.consultants?.map(
                    (consultant, index) => (
                      <Grid item xs={12} sm={6} md={4} key={index}>
                        <CardServiceProviderDivider
                          serviceProvider="Consultor de Crédito"
                          classes={classes}
                          {...consultant}
                        />
                      </Grid>
                    ),
                  )}
                </If>
              </>
            )}
            {loading || error ? null : (
              <>
                <If
                  condition={
                    data?.getDetailsFiiServiceProvidersByOperationHashId
                      ?.legalAdvisors?.length
                  }>
                  <Grid item xs={12} sm={12} md={12}>
                    <Subtitle title="Assessor Jurídico" />
                  </Grid>
                  {data?.getDetailsFiiServiceProvidersByOperationHashId?.legalAdvisors?.map(
                    (legalAdvisor, index) => (
                      <Grid item xs={12} sm={6} md={4} key={index}>
                        <CardServiceProviderDivider
                          serviceProvider="Assessor Jurídico"
                          classes={classes}
                          {...legalAdvisor}
                        />
                      </Grid>
                    ),
                  )}
                </If>
              </>
            )}
            {loading || error ? null : (
              <>
                <If
                  condition={
                    data?.getDetailsFiiServiceProvidersByOperationHashId
                      ?.structurers?.length
                  }>
                  <Grid item xs={12} sm={12} md={12}>
                    <Subtitle title="Estruturador" />
                  </Grid>
                  {data?.getDetailsFiiServiceProvidersByOperationHashId?.structurers?.map(
                    (structure, index) => (
                      <Grid item xs={12} sm={6} md={4} key={index}>
                        <CardServiceProviderDivider
                          serviceProvider="Estruturador"
                          classes={classes}
                          {...structure}
                        />
                      </Grid>
                    ),
                  )}
                </If>
              </>
            )}
            {loading || error ? null : (
              <>
                <If
                  condition={
                    data?.getDetailsFiiServiceProvidersByOperationHashId
                      ?.servicers?.length
                  }>
                  <Grid item xs={12} sm={12} md={12}>
                    <Subtitle title="Prestadores de serviço" />
                  </Grid>
                  {data?.getDetailsFiiServiceProvidersByOperationHashId?.servicers?.map(
                    (servicer, index) => (
                      <Grid item xs={12} sm={6} md={4} key={index}>
                        <CardServiceProviderDivider
                          serviceProvider="Prestadores de serviço"
                          classes={classes}
                          {...servicer}
                        />
                      </Grid>
                    ),
                  )}
                </If>
              </>
            )}
            {loading || error ? null : (
              <>
                <If
                  condition={
                    data?.getDetailsFiiServiceProvidersByOperationHashId
                      ?.auditors?.length
                  }>
                  <Grid item xs={12} sm={12} md={12}>
                    <Subtitle title="Auditor" />
                  </Grid>
                  {data?.getDetailsFiiServiceProvidersByOperationHashId?.auditors?.map(
                    (auditor, index) => (
                      <Grid item xs={12} sm={6} md={4} key={index}>
                        <CardServiceProviderDivider
                          serviceProvider="Auditor"
                          classes={classes}
                          {...auditor}
                        />
                      </Grid>
                    ),
                  )}
                </If>
              </>
            )}
          </Grid>
        </If>
      </Box>
    </Box>
  );
}
